import styled from 'styled-components';
import { hexToRgba } from '../../../utils/style';
import { NewStyleColor } from '../../../utils/styles-constants';

const SharedDocumentsContainer = styled('div')`
	height: 110px;
	border-bottom: solid 1px ${hexToRgba(NewStyleColor.Grey300, 94)};
	padding: 10px 15px;
	font-size: 13px;
	overflow: auto;
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-content: flex-start;
`;

const SharedDocumentsContent = styled('div')`
	width: 150px;
	font-size: 13px;
	font-weight: 400;
	color: ${NewStyleColor.Grey600};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	margin: 10px 30px 10px 0;
`;

export { SharedDocumentsContainer, SharedDocumentsContent };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/SharedDocuments/styles.ts